<template>
  <div class="element-content-checkbox spread">
    <ul>
      <li v-for="(item, index) in items">
        <div class="container" @click="clickOptions(index)">
          <div class="item-label">{{ item.name }}</div>
        </div>
      </li>
    </ul>

  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "index", "requirement", "usage" ],
  data() {
    return {
      status: {
        popup: false,
        index: '',
        option: -1,
      }
    }
  },
  computed: {
    isMultiple(){
      return this.items && this.items.length > 1;
    },
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created(){
    this.$watch( "isMultiple", isMultiple => {
      if( isMultiple && !Array.isArray( this.value ) ){
        this.$emit( "input", []);
      };
    }, { immediate: true });
  },
  methods: {
    clickOptions(index){
      /*if(this.status.index != index && this.status.popup){
        this.status.popup = true;
        this.status.option = this.index;
        this.status.index = index;
      } else {
        this.status.popup = !this.status.popup;
        this.status.option = this.index;
        this.status.index = index;
      }
      this.$emit( "status", this.status );*/
    },
    selectItem( value ){
      if( this.isMultiple ){
        if( this.value.indexOf( value ) >= 0 ){
          this.$emit( "input", this.value.filter( o => o != value ) );
        }else{
          this.$emit( "input", this.value.concat( [ value ] ) );
        };
      }else{
        if( this.value ){
          this.$emit( "input", false );
        }else{
          this.$emit( "input", true );
        };
      };
    }
  }
}
</script>
